$(document).ready(function () { 
    $(document).on('click', '[data-accordion-trigger]', function (e) {
      e.preventDefault();
  
      var Collapsible = $(this).closest('[data-accordion-section]');
  
      var parentCollapsible = $(this).closest('[data-accordion]');
      var collapsibleInner = parentCollapsible.find('[data-accordion-content]');
  
      if ($(this).attr('aria-expanded') === 'false') {
        Collapsible.find('[data-accordion-trigger]').attr('aria-expanded', 'false');
        Collapsible.find('[data-accordion-content]').slideUp();
  
        $(this).attr('aria-expanded', 'true');
        collapsibleInner.slideDown();
  
      } else {
        $(this).attr('aria-expanded', 'false');
        collapsibleInner.slideUp();
      }
    });
});

//Collection
class CollectionDescription extends HTMLElement {
  constructor(){
    super();
    this.buttonReadMore = this.querySelector('.js-read-more');
    this.buttonReadLess = this.querySelector('.js-read-less');
    this.collectionContent = this.querySelector('.collection__description--content');
    let heightContent;

    if ( document.querySelector('body').offsetWidth > 749) {
      heightContent = 192;
    } else {
      heightContent = 96;
    }    

    if (this.collectionContent.offsetHeight > heightContent ) {
      this.buttonReadMore.classList.add('active');
      this.collectionContent.classList.add('hide-content');
    }

    this.buttonReadMore.addEventListener('click', this.showContent.bind(this));
    this.buttonReadLess.addEventListener('click', this.hideContent.bind(this));
  }

  showContent() {
    this.collectionContent.classList.add('active');
    this.collectionContent.classList.remove('hide-content');
    this.buttonReadMore.classList.remove('active');
    this.buttonReadLess.classList.add('active');
  }

  hideContent() {
    this.collectionContent.classList.remove('active');
    this.buttonReadMore.classList.add('active');
    this.buttonReadLess.classList.remove('active');
    this.collectionContent.classList.add('hide-content');
  }

}

customElements.define('collection-desctiption', CollectionDescription);

// Product custom branding
class CustomBranding extends HTMLElement {
  constructor() {
    super();
    this.label = this.querySelector('label');
    this.minProduct = this.getAttribute('data-min-product');
    this.quantity = document.querySelector('product-info .quantity__input');
    this.customPhoto = this.querySelector('.custom-branding__photo');
    this.customInput = this.customPhoto.querySelector('input');
    this.customLabel = this.customPhoto.querySelector('label');
    this.fieldCustom = this.customPhoto.querySelector('.custom-branding__file');
    this.buttonClose = this.customPhoto.querySelector('.custom__close');


    this.handleCheckBox();
    this.isActiveCustomPhoto();
    this.isActiveFile();
    this.isRemoveFile();
  }
  
  handleCheckBox() {
    this.quantity.addEventListener('change', () => {
      if ( this.quantity.value >= this.minProduct ) {
        this.label.classList.add('active');   
      } else {
        this.label.classList.remove('active');
        if(this.label.querySelector('input')) {
          this.label.querySelector('input').checked = false;
        }
        this.customPhoto.style.display = 'none';
      }
    });
  }

  isActiveCustomPhoto() {
    if(this.label.querySelector('input')) {
      this.label.querySelector('input').addEventListener('change', () => {
        if ( this.label.querySelector('input').checked ) {
          this.customPhoto.style.display = 'block';
        } else {
          this.customPhoto.style.display = 'none';
        }
      });
    }
  }

  isActiveFile() {
    this.customInput.addEventListener('change', () => {
      if (this.customInput.value) {
        this.customInput.classList.add('active');
        this.customLabel.style.display = 'none'; 
        this.fieldCustom.classList.add('hide-background');
        this.buttonClose.style.display = 'block';
      }
    });    
  }

  isRemoveFile() {
    if(this.buttonClose) {
      this.buttonClose.addEventListener('click', () => {
        this.customInput.classList.remove('active');
        this.customLabel.style.display = 'block';
        this.buttonClose.style.display = 'none';
        this.fieldCustom.classList.remove('hide-background');
      });
    }
  }
}

customElements.define('custom-branding', CustomBranding);

//Show popup click and collect
class ClickCollect extends HTMLElement {
  constructor() {
    super();
    this.contents = this.querySelectorAll('.click-collect__content p');
    this.shortCutWrap = document.querySelector('.click-collect__shortcut span');
    this.popup = this.querySelector('.click-collect__popup');
    const buttonShow = document.querySelector('.click-collect__shortcut .button-show');
    this.buttonClose = this.querySelector('.button-close')
    this.overlay = this.querySelector('.modal-overlay');

    this.isCreateShortCut();
    if (buttonShow) {
      buttonShow.addEventListener('click', this.showPopup.bind(this)); 
    }

    this.buttonClose.addEventListener('click', this.hidePopup.bind(this));
  }

  isCreateShortCut() {
    this.shortCutWrap.innerText = this.contents[0].textContent;
  }

  showPopup() {    
    this.popup.classList.add('active');    
    this.overlay.classList.add('active');    
  }

  hidePopup() {
    this.popup.classList.remove('active');    
    this.overlay.classList.remove('active');    
  }
}

customElements.define('click-collect', ClickCollect);